import axios from '@/shared/utils/axios-init';


// forming alphabetically sorted arrays of currencies codes
//------------------------------------------------------------
function sortCurrencies(currenciesData, currenciesArray) {
  currenciesData
    .sort((a, b) => {
      if (a.code.toLowerCase() < b.code.toLowerCase()) return -1;
      if (a.code.toLowerCase() > b.code.toLowerCase()) return 1;
      return 0;
    })
    .forEach((el) => {
      currenciesArray.push(el.code);
    });
}


const initialState = {
  userDealsData: [],
  baseCurrencies: [],
  quoteCurrencies: [],
};


const getters = {
  getUserDealsData(state) {
    return state.userDealsData;
  },
  getBaseCurrencies(state) {
    return state.baseCurrencies;
  },
  getQuoteCurrencies(state) {
    return state.quoteCurrencies;
  },
};

const mutations = {
  setUserDealsData(state, data) {
    state.userDealsData = data;
  },
  setBaseCurrencies(state, data) {
    state.baseCurrencies = data;
  },
  setQuoteCurrencies(state, data) {
    state.quoteCurrencies = data;
  },
};

const actions = {
  async fetchUserDealsData({ commit }) {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const data = await axios.post('/cabinet/deals', { }, { headers: { Authorization: `Bearer ${token}` } });
      const userDealsData = data.data.deals;
      const baseCurrenciesData = data.data.base_currencies;
      const quoteCurrenciesData = data.data.quoted_currencies;

      const baseCurrenciesArr = ['All'];
      const quoteCurrenciesArr = ['All'];

      sortCurrencies(baseCurrenciesData, baseCurrenciesArr);
      sortCurrencies(quoteCurrenciesData, quoteCurrenciesArr);

      commit('setUserDealsData', userDealsData);
      commit('setBaseCurrencies', baseCurrenciesArr);
      commit('setQuoteCurrencies', quoteCurrenciesArr);

      return data;
    } catch (error) {
      return error.response;
    }
  },
};


export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/modules/Account/modules/deals.js